import { createFileRoute } from "@tanstack/react-router";
import BookingBuildingSettings from "@/components/building_admin/building_admin_settings/booking";
import { buildingOptions } from "@/api";
import { SettingsSubPage } from "@/components/building_admin/building_admin_settings/SettingsSubPage";
import { useWelcomeBookingAccess } from "@/hooks/useWelcomeBookingAccess";
import { useRouterStore } from "@/store/zustandStore";

const PageComponent = () => {
  const { allowWelcomeBookingAccess } = useWelcomeBookingAccess(true);
  const card = {
    icon: "date_range",
    value: "booking",
    label: "Welcome Booking",
    enabled: allowWelcomeBookingAccess,
    to: "/building/settings/booking",
    descriptionKey: "PAGES.BUILDING_SETTINGS.MODULE_DESCRIPTIONS.BOOKING",
  };
  return (
    <SettingsSubPage
      cardOptions={card}
      PageComponent={BookingBuildingSettings}
      label="Booking"
      path="/building/settings/booking"
      allowReceptionistAccess
    />
  );
};

export const Route = createFileRoute("/_portal/building/settings/booking")({
  component: PageComponent,
  loader: () => {
    const { queryClient } = useRouterStore.getState();
    if (!queryClient) return;
    queryClient.ensureQueryData(buildingOptions);
  },
});
